import React from 'react';
import { Column, UseFiltersColumnOptions } from 'react-table';

import { Quality } from '../../../../Types/LotDetailQuality';
import NoFilter from '../../../../DataTable/datatable.nofilter';
import QualityCell from './QualityCell';

export interface QualityColumnProps {
    header: string,
    qualityType: string,
    showConfidence?: boolean;
}

function QualityColumn({ header, qualityType, showConfidence = false }: QualityColumnProps): Column<Quality> & UseFiltersColumnOptions<Quality> {
    return {
        Header: header,
        id: header,
        accessor: "qualityValues",
        Cell: (props) => <QualityCell row={props.row} qualityType={qualityType} showConfidence={showConfidence} />,
        Filter: NoFilter
    };
}

export default QualityColumn;